import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit'
import axios, { AxiosError } from 'axios'

interface SkillHierarchyInitialStateType {
  data: {
    name: string,
    value: number,
    children: [{
      name: string,
      value: number
      children: [{
        name: string,
        value: number,
        description: string,
        experience: string,
        firstYearUsed: string,
        lastYearUsed: string,
        selfRating: string,
        synonyms: string,
        versions: [],
        whyIUsed: string,
      }],
    }]
  }
  loading: boolean
  status: number | null
  errorStatus: number | null
}

const initialState: SkillHierarchyInitialStateType = {
  data: {
    name: "",
    value: 0,
    children: [{
      name: "",
      value: 0,
      children: [{
        name: "",
        value: 0,
        description: "",
        experience: "",
        firstYearUsed: "",
        lastYearUsed: "",
        selfRating: "",
        synonyms: "",
        versions: [],
        whyIUsed: ""
      }]
    }]
  },
  loading: false,
  status: null,
  errorStatus: null
}

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const getSkillHierarchy = createAsyncThunk('SkillHierarchySlice/getSkillHierarchy', async (_, thunkApi) => {
  try {
    const response = await axios.get(apiUrl + '/skills/hierarchy')
    const data = await response.data.data
    return thunkApi.fulfillWithValue(data)
  } catch (error) {
    const err = error as AxiosError
    return thunkApi.rejectWithValue(err.response?.status)
  }
})

const SkillHierarchySlice = createSlice({
  name: "SkillHierarchySlice",
  initialState,
  reducers: {
    getValue: (state, action) => {
      state.data = action.payload
    },
    resetValue: (state) => {
      state.data = { name: "", value: 0, children: [{ name: "", value: 0, children: [{ name: "", value: 0, description: "", experience: "", firstYearUsed: "", lastYearUsed: "", selfRating: "", synonyms: "", versions: [], whyIUsed: "" }] }] }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getSkillHierarchy.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getSkillHierarchy.fulfilled, (state, action) => {
      state.data = action.payload
    })
    builder.addCase(getSkillHierarchy.rejected, (state, action) => {
      state.errorStatus = action.payload as number
    })
    builder.addMatcher(isAnyOf(
      getSkillHierarchy.fulfilled, getSkillHierarchy.rejected), (state) => {
        state.loading = false
      })
  }
})

const SkillHierarchyThunks = {
  getSkillHierarchy,
}

export const SkillHierarchyServices = {
  ...SkillHierarchyThunks,
  actions: SkillHierarchySlice.actions,
}

const SkillHierarchyReducer = SkillHierarchySlice.reducer
export default SkillHierarchyReducer